module.exports = "<footer class=\"main-footer\">\n  <b>© Copyright {{ currentYear }}</b>, All right reserved, Powered by <b>BUSoft Tech</b>\n</footer>"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/layouts/footer/footer.component.html
// module id = ../../../../../src/app/layouts/footer/footer.component.html
// module chunks = main